import { log } from '@/log'
import ContactLensFKU from '@/models/item/fku/contact-lens'

export function moveCarousel(fku: ContactLensFKU): void {
  const index = getIndexOfFirstMediumInFku(fku.lensImageMediaId)
  if (!index) {
    log.error('クリックしたFKUの最初の画像のインデックスの取得に失敗しました。')

    return
  }

  const types = ['pc', 'sp']
  types.forEach((type) => {
    $(`#js-thumb-${type}-main`).slick('slickGoTo', index)
  })
}

function getIndexOfFirstMediumInFku(mediaId: string): string | undefined {
  const elem = document.querySelector(`div[data-media-id="${mediaId}"]`)

  return elem ? (elem as HTMLElement).dataset.indexOfFirstMediumInFku : undefined
}
